import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import Heading from '@stories/Components/Global/Typography/Heading';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 200%;
    background-color: #e3e3e3;
    z-index: 1;
    transform: translateX(-50%) rotate(-6deg);
    border-top: 10px solid ${brand.primary.alt};
    display: none;

    @media ${from(Device.Tablet)} {
      display: block;
      height: 160px;
      top: 80px;
    }

    @media ${from(Device.Desktop)} {
      height: 320px;
      top: 160px;
    }
  }

  @media ${from(Device.Tablet)} {
    padding-top: 160px;
  }

  @media ${from(Device.Desktop)} {
    padding-top: 320px;
  }
`;
const Inner = styled.div `
  background-color: ${brand.grey.grey89};
  position: relative;
  z-index: 1;
  padding: 40px 0px;

  @media ${from(Device.Tablet)} {
    padding: 0px;
    padding-bottom: 80px;
  }

  @media ${from(Device.Desktop)} {
    padding-bottom: 160px;
  }
`;
const Content = styled.div `
  grid-column: span 12;
  text-align: center;

  @media ${from(Device.TabletLarge)} {
    grid-column: 4 / span 6;
  }
`;
const Icons = styled.div `
  grid-column: span 12;
  margin-top: 45px;

  @media ${from(Device.Desktop)} {
    margin-top: 90px;
  }
`;
const IconCard = styled.div `
  grid-column: span 12;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${from(Device.Mobile)} {
    grid-column: span 6;
  }

  @media ${from(Device.Tablet)} {
    grid-column: span 3;
  }
`;
const IconImage = styled.div `
  margin-bottom: 30px;
`;
const IconTitle = styled.p `
  text-align: center;
  color: ${brand.grey.grey20};
  font-weight: bold;
`;
const Title = styled(Heading) `
  ${fonts.DaxPro.Regular}
  color: ${brand.primary.alt};
`;
export const PromoIconsStyles = {
    Container,
    Inner,
    Content,
    Icons,
    IconCard,
    IconImage,
    IconTitle,
    Title,
};
